import script from "./imageDynamicEffects.vue?vue&type=script&setup=true&lang=js"
export * from "./imageDynamicEffects.vue?vue&type=script&setup=true&lang=js"

import "./imageDynamicEffects.vue?vue&type=style&index=0&id=33367ecc&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-lite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33367ecc"]])

export default __exports__